<template>
  <div>
    <v-dialog class="my-0" v-model="store.state.topLocationDialogVisible" style="max-height: 75vh; max-width: 85vw" v-if="store.state.topLocationDialogVisible" :retain-focus="false">
      <v-card rounded="xl" max-height="75vh" style="overflow-y: hidden">
        <v-img :src="store.state.topLocationDialogLocation.pic_url" height="16vh" gradient="to top right, rgba(0,0,0,.1), rgba(0,0,0,.7)">
          <v-btn color="white" icon small top right fab style="position: absolute; top: 1px; right: 1px;" @click="$store.commit('closeLocationDialog')"><v-icon>mdi-close</v-icon></v-btn>
          <div style="color: white" class="picAttribution" v-html="store.state.topLocationDialogLocation.pic_att"></div>
          <v-card-title style="color: white">{{ store.state.topLocationDialogLocation.name.split(", ")[0] }}</v-card-title>
          <v-card-subtitle style="color: white">{{store.state.topLocationDialogLocation.name.split(", ")[1]}}</v-card-subtitle>
        </v-img>
        <v-card-title>Total of {{store.state.topLocationDialogLocation.nomad_count}} Nomads</v-card-title>
        <v-card-subtitle>{{store.state.topLocationDialogLocation.nomad_count - store.state.locationNomads.length}} Private Profiles</v-card-subtitle>
        <v-list style="max-height: 40vh; overflow-y: auto">
          <v-list-item v-for="nomad in store.state.locationNomads" :key="nomad.users_data.id" @click="openProfileCard(nomad.users_data.id)">
            <v-list-item-avatar size="60" >
              <v-img
                  :src="nomad.users_data.avatar_url || require('@/assets/profile_placeholder.png')"
                  lazy-src="~@/assets/profile_placeholder.png"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{nomad.users_data.full_name}}</v-list-item-title>
<!--              <v-list-item-subtitle >{{dateRangeText([nomad.arrival_date, nomad.departure_date])}}</v-list-item-subtitle>-->
              <v-list-item-subtitle v-if="nomad.departure_date">{{formattedDateRange(nomad.arrival_date, nomad.departure_date)}}</v-list-item-subtitle>
              <v-list-item-subtitle v-else>Here Since {{formattedDate(nomad.arrival_date)}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {store} from "@/store";

export default {
  name: "LocationDialog",
  computed: {
    store() {
      return store
    }
  },
/*
  components: {ProfileCard},
*/
  data() {
    return {
      locationNomads: [],
      dialogLocation: {"locationName":" , "},
      topLocationDialogLocation: {"locationName":" , "},
      dialogVisible: false,
      topLocationDialogVisible: false,
      existingPlace: null,
      userProfileData: {},
      userProfileDepartureDate: null,
      profileCardKey: 0,
    }
  },

  methods: {
    dateRangeText(stayDates) {
      return stayDates.join(' ~ ')
    },
    formattedDate(dateString) {
      dateString = dateString + 'T12:00:00'
      let date = new Date(dateString);
      date.setDate(date.getDate());
      const options = { year: "numeric", month: "short", day: "numeric" };
      return date.toLocaleDateString(undefined, options);
    },
    formattedDateRange(arrival, departure) {
      arrival = arrival + 'T12:00:00'
      departure = departure + 'T12:00:00'
      let arrivalDate = new Date(arrival);
      arrivalDate.setDate(arrivalDate.getDate());
      let departureDate = new Date(departure);
      departureDate.setDate(departureDate.getDate());

      const arrivalDay = arrivalDate.getDate();
      const departureDay = departureDate.getDate();
      const arrivalMonth = arrivalDate.toLocaleString('default', { month: 'short' }); // e.g., May
      const arrivalYear = arrivalDate.getFullYear();

      if (arrivalMonth === departureDate.toLocaleString('default', { month: 'short' }) && arrivalYear === departureDate.getFullYear()) {
        return `${arrivalDay} - ${departureDay} ${arrivalMonth}, ${arrivalYear}`
      } else if (arrivalYear === departureDate.getFullYear()) {
        let departureMonth = departureDate.toLocaleString('default', { month: 'short' });
        return `${arrivalMonth} ${arrivalDay} - ${departureMonth} ${departureDay}, ${arrivalYear}`
      } else {
        let departureMonth = departureDate.toLocaleString('default', { month: 'short' });
        return `${arrivalMonth} ${arrivalDay}, ${arrivalYear} - ${departureMonth} ${departureDay}, ${departureDate.getFullYear()}`
      }
    },
    async openProfileCard(user_id) {
      await store.dispatch('getProfileCardData', user_id)
      store.commit('profileDialogOn')
    },
  },
}
</script>


<style scoped>
.topLocationDialog {
  background-color: #A9C9FF;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%);
}
.picAttribution {
  font-size: small;
  left: 10px;
  bottom: 10px;
  position: absolute;
  background-color: #333;
  opacity: 0.8;
  color: white;
}
</style>
